import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { GEOFENCES_MODEL, isCloseTimeNotValid } from '../Model/Model';
import HandleChange from '../../../../../Helpers/HandleChange';
import { toast } from 'react-toastify';
import {useLocation, useNavigate, useParams} from "react-router-dom";
import {
    GetGeofenceById,
    UpdateGeofence
} from "../../../../../reduxToolkit/FineGeofence/FineGeofenceApi";
import {DEFAULT_LATITUDE, DEFAULT_LONGITUDE, errorMsg} from "../../../../../Apis/functions";
import {useDispatch, useSelector} from "react-redux";
import routes from "../../../../../Routes/routes";
import {permissionObj} from "../../../../../Helpers/permission";
/**
 * @Email : sgarcia@ibl.mx
 * @Author: Susana Garcia Rodriguez
 * @jobTittle: Frontend
 */
const GeofencesUpdateApp = () => {
    const { t } = useTranslation();
    const {id} = useParams();
    const dispatch = useDispatch();
    const location = useLocation();
    const navigate = useNavigate();
    const DEV = useSelector((state) => state?.CommonsSlice?.development);
    const {permission} = useSelector((state) => state.authenticatioauthennSlice);
    const { state } = location;
    const disabled = !DEV && !permission?.includes(permissionObj?.WEB_TRAFFIC_MANAGE_GEOFENCES_UPDATE);
    const [emptyFields, setEmptyFields] = useState(false);
    const [geofences, setGeofences] = useState([]);
    const [item, setItem] = useState({...GEOFENCES_MODEL});
    const [dayArray, setDayArray] = useState( []);
    const { handleChange } = HandleChange({ model: item, setModel: setItem });
    const [latitude, setLatitude] = useState(DEFAULT_LATITUDE);
    const [longitude, setLongitude] = useState(DEFAULT_LONGITUDE);
    const [center, setCenter] = useState(null);
    const isCloseTimeInvalid = isCloseTimeNotValid(item.opening, item.closing);
    /**
     * Sync the geofence model and dayArray whenever zones change.
     * Ensures the UI form reflects the current zones.
     */
    useEffect(() => {
        getData();
    }, []);

    const getData = () => {
        dispatch(GetGeofenceById(id)).then(({ payload: { data: { data, success, code } } }) => {
            if (success) {
                setItem(GEOFENCES_MODEL.toSet(data));
                const aux = {...GEOFENCES_MODEL.toSetMap(data, setDayArray)};
                setGeofences([aux]);
                setEmptyFields(false);
                let center = GEOFENCES_MODEL.getGeofenceCenter(aux);
                if(center) {
                    setCenter(center);
                }
            } else {
                errorMsg(code);
            }
        });
    }
    /**
     * Handle update submission of the geofence.
     * Validates required fields and schedule before generating the payload.
     */
    const handleUpdate = () => {
        if (!item.isValidDetails() || !item.isValidSchedule(dayArray) || !item.isValidArea(geofences)) {
            setEmptyFields(true);
            toast.warning(t('please_fill_all_fields'));
            return;
        }

        setEmptyFields(false);
        dispatch(UpdateGeofence(item.toRegister(geofences[0].coordinates, dayArray))).then(({ payload: { data: { success, code } } }) => {
            if (success) {
                toast.success(t('has_been_updated_successfully'));
                getData();
            } else {
                errorMsg(code);
            }
        });
    };

    const handleOnBack = () => {
        navigate(
            routes.traffic.list, {
                state: state
            });
    }

    useEffect(() => {
        if (geofences.length > 0) {
            setEmptyFields(false);
        }
    }, [geofences]);



    return {
        DEV,
        permission,
        t,
        disabled,
        item,
        emptyFields,
        setItem,
        setDayArray,
        dayArray,
        handleChange,
        geofences,
        setGeofences,
        latitude,
        setLatitude,
        longitude,
        setLongitude,
        center,
        handleUpdate,
        handleOnBack,
        isCloseTimeInvalid
    };
};

export default GeofencesUpdateApp;
